'use client';

import { useEffect } from 'react';

interface SchemaInjectorProps {
  organizationSchema?: Record<string, any>;
  webpageSchema?: Record<string, any>;
  softwareApplicationSchema?: Record<string, any>;
  faqSchema?: Record<string, any>;
}

export default function SchemaInjector({
  organizationSchema,
  webpageSchema,
  softwareApplicationSchema,
  faqSchema,
}: SchemaInjectorProps) {
  useEffect(() => {
    const schemas = [
      { id: 'schema-organization', data: organizationSchema },
      { id: 'schema-webpage', data: webpageSchema },
      { id: 'schema-software', data: softwareApplicationSchema },
      { id: 'schema-faq', data: faqSchema },
    ];

    schemas.forEach(({ id, data }) => {
      if (data && !document.getElementById(id)) {
        const script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        script.innerHTML = JSON.stringify(data);
        document.head.appendChild(script);
      }
    });
  }, [organizationSchema, webpageSchema, softwareApplicationSchema, faqSchema]);

  return null;
}
